import React from "react";
import FieldView from "./FieldView";
var GroupField = function GroupField(props) {
  return /*#__PURE__*/React.createElement(FieldView, Object.assign({}, props, {
    wrapperIsLabel: false
  }));
};
export default GroupField;